declare const ScalarFresnel: any; // global constant from engine

export class ScalarFresnelModel {
  edge: number;
  center: number;
  centerBias: number;
  edgeBias: number;
  power: number;

  constructor(value: ScalarFresnelModel = { center: 0, edge: 1, centerBias: 1, edgeBias: 0, power: 1 }) {
    const { edge, center, centerBias, edgeBias, power } = value;
    this.edge = edge;
    this.center = center;
    this.centerBias = centerBias;
    this.edgeBias = edgeBias;
    this.power = power;
  }

  /**
   * Serializes to Engine's Fresnel format
   */
  static toEngine(scalarFresnel: ScalarFresnelModel): [number, number, number, number, number] {
    const { center, edge, centerBias, edgeBias, power } = scalarFresnel;
    return [center, edge, centerBias, edgeBias, power];
  }
}
